import { Button, Modal } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { useModals } from '@/hooks/useModals';
import { removeSearchParam } from '@/utils/tool';

/**
 * 支付成功的弹框
 */
export const PaymentSuccessModal = () => {
  const { t } = useTranslation();
  const { paymentSuccessModalOpened, toggle } = useModals();

  const onClose = () => {
    toggle('paymentSuccessModalOpened', false);
    removeSearchParam('payment');
  };

  return (
    <Modal opened={paymentSuccessModalOpened} onClose={onClose} withCloseButton={false}>
      <div className="bg-white p-6  md:mx-auto">
        <svg viewBox="0 0 24 24" className="text-indigo-800 w-16 h-16 mx-auto my-6">
          <path
            fill="currentColor"
            d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
          ></path>
        </svg>
        <div className="text-center">
          <h3 className="md:text-2xl text-base text-gray-900 font-semibold text-center">
            {t('pricing.current_subscription.payment_success')}
          </h3>
          <p className="text-gray-600 my-2">{t('pricing.current_subscription.payment_success_description')}</p>
          <Button className="mt-6" onClick={onClose}>
            {t('pricing.enjoy')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
